import React from 'react';
import Button from 'src/ui/library/Button';

class WhatIfPres extends React.Component {
  render() {
    const { onGoToCalculator } = this.props;
    return (
      <div>
        <div className="whatif-landing-background" />
        <div className="whatif-backgroundimage" />
        <div className="whatif-landing">
          <div className="whatif-landing-text">
            Our <i>What if...</i> Calculator gives you explicit cost breakdown to help you save on overall assignment costs and successful
            talent management
          </div>
          <Button className="whatif-landing-btn" styleType="primary" onClick={onGoToCalculator}>
            Go to Calculator
          </Button>
        </div>
      </div>
    );
  }
}

export default WhatIfPres;
